import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import { PercentageFormatter } from 'tuc-webui-base/services/Formatters';
import './JobParameters.scss';

const toPercent = value => PercentageFormatter(value, undefined, undefined, { fractionDigits: 2 });

const ParameterFormatters = {
  MIPGap: (value) => {
    let num;
    if (typeof value === 'string') {
      try {
        num = parseFloat(value);
      } catch (e) {
        return value;
      }
    } else {
      num = value;
    }
    return toPercent(num);
  },
}

const JobParameter = ({ parameter }) => {
  const { name, type, value } = parameter;
  return (
    <ListItem
      classes={{ root: 'grb-jobparam-item' }}
    >
      <ListItemText primary={name} secondary={type} />
      <ListItemSecondaryAction>
        <Typography variant="body1">
          {ParameterFormatters[name] ? ParameterFormatters[name](value) : value}
        </Typography>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

JobParameter.propTypes = {
  parameter: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
};

const JobParameters = (props) => {
  const { data: job, jobService } = props;
  const [params, setParameters] = useState([]);
  useEffect(() => {
    jobService.fetchJobParameters(job.id, job)
    .then((ps) => {
      setParameters(ps || []);
    })
    .catch(() => {
      setParameters(null);
    });
  }, [props.data]);

  if (params === null) {
    return <div className="grb-jobparam-noparams">Parameters are not available</div>;
  }
  return (
    <div className="grb-jobparam-list">
      {params.map(param => (
        <List key={param.id || param.name}>
          <JobParameter
            parameter={param}
          />
        </List>
      ))}
    </div>
  );
};

JobParameters.propTypes = {
  data: PropTypes.shape({}).isRequired,
  jobService: PropTypes.shape({
    fetchJobParameters: PropTypes.func.isRequired,
  }).isRequired,
};

JobParameters.defaultProps = {
};

export default JobParameters;
